import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "redux/actions/setAppActions";
import { Alert } from "components/Alert";

/**
 * @api {get} /psych/lose восстановления пароля психолога
 * @apiGroup psychologists
 * @apiName восстановления пароля психолога
 *
 * @apiDescription <p>Страница восстановления пароля психолога</p>
 * <p>Компонент <code>LosePassPage.js</code> <a href="../client/src/pages/LosePassPage.js">ссылка на файл</a></p>
 */

/**
 * @api {get} /pupil/lose восстановления пароля ученика
 * @apiGroup pupils
 * @apiName восстановления пароля ученика
 *
 * @apiDescription <p>Страница восстановления пароля ученика</p>
 * <p>Компонент <code>LosePassPage.js</code> <a href="../client/src/pages/LosePassPage.js">ссылка на файл</a></p>
 */

export const LosePassPage = ({ role }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const { alert } = useSelector((state) => state.app);
    const { user } = useSelector((state) => state.auth);
    const [form, setForm] = useState({ email: "" });

    const changeHandler = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };
    useEffect(() => {
        if (user) {
            setForm({ ...form, email: user.email });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);
    const sendPassHandler = async () => {
        setLoading(true);
        try {
            const res = await fetch(`/api/${role}/lose/password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || "Что-то пошло не так");
            }

            dispatch(showAlert({ type: "success", text: data.message }));
            setLoading(false);
        } catch (error) {
            dispatch(showAlert({ type: "error", text: error.message }));
            setLoading(false);
        }
    };
    if (role === "pupil") {
        return (
            <div className="main">
                {!!alert && <Alert text={alert.text} type={alert.type} />}
                <div className="page auth-page">
                    <header className="page__header">
                        <p className="page__title">Восстановление пароля</p>
                    </header>
                    <div className="auth-page__wrapper">
                        <div className="auth-page__header">
                            <h3>Забыли пароль?</h3>
                        </div>
                        <div className="auth-page__input-group">
                            <div className="input-field">
                                <input
                                    id="email"
                                    type="text"
                                    name="email"
                                    value={form.email}
                                    onChange={changeHandler}
                                    placeholder="Укажите вашу почту"
                                />
                                <label htmlFor="email">Эл. почта</label>
                            </div>
                        </div>
                        <button
                            disabled={loading}
                            onClick={sendPassHandler}
                            className="main-btn auth-page__btn"
                        >
                            Отправить пароль на почту
                        </button>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="main">
            {!!alert && <Alert text={alert.text} type={alert.type} />}
            <div className="page auth-page">
                <header className="page__header">
                    <p className="page__title">Восстановление пароля</p>
                </header>
                <div className="auth-page__wrapper">
                    <div className="auth-page__header">
                        <h3>Забыли пароль?</h3>
                    </div>
                    <div className="auth-page__input-group">
                        <div className="input-field">
                            <input
                                id="email"
                                type="text"
                                name="email"
                                value={form.email}
                                placeholder="Ваша почта"
                                onChange={changeHandler}
                            />
                            <label htmlFor="email">Ваша почта</label>
                        </div>
                        {role === "psych" && <Link to={"/psych/login"}>Уже есть пароль?</Link>}
                    </div>
                    <button
                        disabled={loading}
                        onClick={sendPassHandler}
                        className="main-btn auth-page__btn"
                    >
                        Отправить пароль на почту
                    </button>
                </div>
            </div>
        </div>
    );
};
